import type { Control, UseFormSetValue } from 'react-hook-form';
import type { UpdateEndorsementDataPayload } from '@root/@types/types';
import { EndorsementPremiumChange } from '@root/@types/types';

export type EndorsementFormState = Partial<UpdateEndorsementDataPayload> & {
  parentSubmissionId?: string;
};

export type FormState = Partial<UpdateEndorsementDataPayload> & {
  parentSubmissionId?: string;
};

export interface StepProps {
  control: Control<EndorsementFormState>;
  formValues: EndorsementFormState;
  isReadOnly?: boolean;
  setValue?: UseFormSetValue<EndorsementFormState>;
}

export enum EndorsementStep {
  ParentSelection = 0, // Standalone only
  SummaryTemplate = 1,
  BasicInfo = 2,
  ReasonPremium = 3,
}

export const isConditionalPremiumOption = (premium_change?: EndorsementPremiumChange) =>
  Boolean(
    premium_change && [EndorsementPremiumChange.ADDITION, EndorsementPremiumChange.RETURN].includes(premium_change),
  );
